// Regras oficiais fornecidas pela empresa. Não substituir por interpretações.
export default {
  "title": "REGRAS DA CASA",
  "eyebrow": "03 / REGRAS E PROCESSOS",
  "support": "Organização, respeito, segurança e clareza para uma operação comercial de excelência.",
  "intro": "Estas regras existem para garantir organização, respeito entre os corretores, segurança jurídica e uma experiência de excelência para proprietários e clientes da 61 Imóveis.",
  "chapters": [
    {
      "id": 1,
      "title": "SOBRE CAPTAÇÃO E COMERCIALIZAÇÃO DE IMÓVEIS",
      "label": "Captação e Comercialização de Imóveis",
      "intro": [
        "Estas regras existem para garantir organização, respeito entre os corretores, segurança jurídica e uma experiência de excelência para proprietários e clientes da 61 Imóveis."
      ],
      "rules": [
        {
          "number": 1,
          "title": "Prioridade da captação",
          "lines": [
            "A prioridade da captação pertence ao corretor que concluir corretamente todo o processo primeiro.",
            "Não basta conhecer o proprietário, conversar sobre o imóvel, realizar uma visita ou demonstrar interesse.",
            "Para que a captação seja considerada válida, é necessário:",
            "Autorização de Venda válida e conforme o padrão da 61 Imóveis.",
            "Endereço completo e correto, especialmente CEP e número do imóvel.",
            "Cadastro completo no CRM, com todas as informações obrigatórias.",
            "Registro correto da captação no sistema.",
            "Quando dois corretores captarem o mesmo imóvel, a disputa será analisada nesta ordem:",
            "Primeiro, será verificado se as duas captações possuem autorização válida.",
            "Depois, será conferido se o endereço está completo e correto.",
            "Caso uma delas não cumpra algum desses requisitos, a prioridade será da outra.",
            "Se as duas estiverem corretas, terá prioridade a captação registrada primeiro no sistema.",
            "O percentual de comissão e a existência de exclusividade não são critérios de desempate."
          ]
        },
        {
          "number": 2,
          "title": "O captador é o responsável pelo proprietário",
          "lines": [
            "Após a captação ser concluída e registrada corretamente, todo contato relacionado ao imóvel deverá ser realizado exclusivamente pelo corretor captador, pelo gestor da sua equipe ou pela 61 Imóveis.",
            "Isso inclui:",
            "Negociação da captação.",
            "Contato e acompanhamento do proprietário.",
            "Solicitações ao proprietário.",
            "Alteração de preço ou estratégia comercial.",
            "Agendamento de visitas.",
            "Autorização para fotos, vídeos e materiais de divulgação.",
            "Ajustes nos anúncios.",
            "Dúvidas sobre o imóvel.",
            "Informações sobre a comercialização.",
            "Nenhum outro corretor poderá tratar diretamente desses assuntos com o proprietário."
          ]
        },
        {
          "number": 3,
          "title": "É proibido interferir na captação de outro corretor",
          "lines": [
            "Não é permitido:",
            "Tentar convencer o proprietário a mudar de captador.",
            "Interferir em uma negociação de captação.",
            "Atravessar uma captação já realizada.",
            "Aproveitar amizade ou relacionamento com o proprietário para influenciar a captação.",
            "Aliciar proprietários vinculados a outro corretor.",
            "Tentar captar um imóvel que já pertence à carteira da 61 Imóveis.",
            "Mesmo que outro corretor conheça o proprietário há muitos anos, a captação pertence ao profissional que concluiu corretamente o processo primeiro."
          ]
        },
        {
          "number": 4,
          "title": "Mudança de captador",
          "lines": [
            "Após a captação ser lançada corretamente, o proprietário não poderá trocar diretamente de corretor captador.",
            "Caso o proprietário solicite a mudança, a captação permanecerá com o profissional que realizou corretamente o processo.",
            "Nenhuma mudança poderá ser negociada diretamente entre proprietário e corretor.",
            "Qualquer problema deverá ser comunicado e resolvido por intermédio do gestor."
          ]
        },
        {
          "number": 5,
          "title": "Saída do captador da 61 Imóveis",
          "lines": [
            "Enquanto o captador fizer parte da 61 Imóveis, ele será o responsável pelo imóvel e pela comunicação com o proprietário.",
            "Após o encerramento da parceria do captador com a empresa, a responsabilidade pelo imóvel passará ao gerente da equipe.",
            "O gerente deverá assumir o acompanhamento e contato do proprietário, organizar as visitas e definir internamente a continuidade da gestão da captação.",
            "Nenhum corretor deverá assumir diretamente o contato sem o alinhamento e a autorização do gerente."
          ]
        },
        {
          "number": 6,
          "title": "Quarentena para nova captação",
          "lines": [
            "Quando o proprietário solicitar a retirada do imóvel da carteira da 61 Imóveis, o mesmo captador poderá retomar a captação posteriormente, caso o proprietário autorize.",
            "Para que o imóvel seja captado por outro corretor, deverá ser respeitado o período de quarentena de 30 dias."
          ]
        },
        {
          "number": 7,
          "title": "Imóveis Internos",
          "lines": [
            "Quando um imóvel permanecer classificado como Interno por mais de 60 dias, outro corretor poderá obter do proprietário uma autorização para divulgação pública do imóvel.",
            "Imóveis divulgados apenas no Site da 61 Imóveis e instagram é externo",
            "Nessa situação:",
            "A partir da publicação, o captador original e o novo captador dividirão a comissão de captação, conforme as regras da empresa.",
            "Somente produzirá efeitos após a publicação do imóvel como Público.",
            "A partir da publicação, o captador original e o captador que obtiver a autorização dividirão a comissão de captação.",
            "Os leads gerados após a publicação serão distribuídos de forma intercalada entre o captador e o corretor que obteve a autorização pública.",
            "Vendas originadas de visitas realizadas antes da publicação do imóvel como Público permanecerão vinculadas ao captador original, que fará jus integralmente à comissão de captação correspondente.",
            "Essa regra aplica-se exclusivamente aos imóveis que permanecerem classificados como Internos por período superior a 60 dias e cuja autorização para divulgação pública tenha sido obtida por outro corretor.",
            "Caso o captador original e o corretor que obteve a autorização pública sejam de equipes diferentes, a comissão dos gerentes referente à captação será DIVIDIDA."
          ]
        },
        {
          "number": 8,
          "title": "Agendamento e responsabilidade pelas visitas",
          "lines": [
            "As visitas ao imóvel deverão ser organizadas por meio do corretor captador.",
            "O captador é responsável por:",
            "Tratar o agendamento com o proprietário.",
            "Confirmar a disponibilidade do imóvel.",
            "Organizar o acesso ao imóvel.",
            "Informar restrições, condições e orientações registradas na captação.",
            "Apresentar as características do imóvel quando acompanhar a visita.",
            "Quando outro corretor levar um comprador, o captador poderá apresentar o imóvel e esclarecer dúvidas sobre suas características.",
            "Entretanto, o atendimento, a orientação comercial e a condução do comprador permanecem sob responsabilidade do corretor que levou o cliente. O captador não poderá assumir o atendimento, sugerir outros imóveis ou interferir na estratégia comercial do corretor parceiro."
          ]
        },
        {
          "number": 9,
          "title": "Assuntos da captação durante a visita",
          "lines": [
            "O corretor visitante não deverá tratar diretamente com o proprietário sobre:",
            "Divulgação.",
            "Estratégia de venda.",
            "Anúncios.",
            "Fotos ou vídeos.",
            "Preço.",
            "Produção de conteúdo.",
            "Negociação da captação.",
            "Alterações no imóvel.",
            "Caso o proprietário faça alguma pergunta, o corretor deverá informar que o assunto será encaminhado ao captador.",
            "Sugestão de resposta: “Esse assunto é tratado pelo corretor captador. Vou pedir para que ele entre em contato com você.”"
          ]
        },
        {
          "number": 10,
          "title": "Disponibilidade do imóvel",
          "lines": [
            "Após ser captado, o imóvel deverá estar disponível para visitas do captador e dos demais corretores da empresa nas mesmas condições e prazos.",
            "O captador não poderá criar vantagens exclusivas para si ou dificultar o atendimento de clientes de outros corretores.",
            "Restrições de acesso ou visita somente poderão ser aplicadas quando:",
            "Solicitadas pelo proprietário.",
            "Necessárias em razão de uma negociação em andamento.",
            "Autorizadas pelo gestor.",
            "Ao suspender as visitas, a restrição será aplicada a todos, inclusive ao próprio captador."
          ]
        },
        {
          "number": 11,
          "title": "Suspensão e bloqueio de visitas",
          "lines": [
            "O captador poderá solicitar a suspensão das visitas apenas quando:",
            "O imóvel estiver em negociação.",
            "O proprietário solicitar que não sejam realizadas visitas naquele momento.",
            "A impossibilidade deverá ser com autorização do seu gestor.",
            "Não é permitido bloquear o imóvel para impedir visitas de outros corretores e continuar realizando visitas particulares com outros clientes."
          ]
        },
        {
          "number": 12,
          "title": "Divulgação do imóvel",
          "lines": [
            "O imóvel captado deverá estar disponível para divulgação pelos corretores da empresa, salvo quando houver restrição expressa do proprietário ou autorização específica do gestor.",
            "O captador deverá registrar no cadastro todas as limitações relacionadas à divulgação no CRM, incluindo:",
            "Proibição de divulgação pública.",
            "Restrição de fotos.",
            "Restrição de vídeos.",
            "Restrição de endereço ou identificação.",
            "Impossibilidade de publicação por outros corretores.",
            "Outras orientações determinadas pelo proprietário.",
            "Todas as informações registradas deverão ser respeitadas."
          ]
        },
        {
          "number": 13,
          "title": "Divulgação de imóvel captado por outro corretor",
          "lines": [
            "Antes de divulgar um imóvel captado por outro profissional, o corretor deverá:",
            "Consultar as observações internas da captação.",
            "Verificar se existem restrições do proprietário.",
            "Informar o captador.",
            "Obter sua autorização quando necessário.",
            "Utilizar apenas informações e materiais oficiais.",
            "Não alterar fotos, textos, preços ou condições sem autorização."
          ]
        },
        {
          "number": 14,
          "title": "Produção fotográfica, audiovisual e publicitária",
          "lines": [
            "Toda produção realizada no imóvel deverá ser tratada exclusivamente com o captador.",
            "Nenhum outro corretor poderá, sem sua autorização:",
            "Agendar fotógrafo.",
            "Realizar ensaio fotográfico.",
            "Produzir ou gravar vídeos.",
            "Contratar produção audiovisual.",
            "Criar materiais publicitários no imóvel.",
            "Solicitar diretamente ao proprietário acesso para produção de conteúdo.",
            "Pedir alterações nas fotos, vídeos ou anúncios.",
            "Toda interação com o proprietário para esses fins deverá ocorrer por intermédio do captador ou do gestor da equipe."
          ]
        },
        {
          "number": 15,
          "title": "Responsabilidade pela qualidade da divulgação",
          "lines": [
            "O captador é responsável por garantir que o imóvel esteja divulgado corretamente.",
            "É sua responsabilidade:",
            "Conferir as informações do cadastro.",
            "Garantir que o endereço esteja correto.",
            "Manter preço e disponibilidade atualizados.",
            "Conferir características, metragem, valores e comissão.",
            "Verificar a qualidade e a ordem das fotos.",
            "Revisar o texto do anúncio.",
            "Acompanhar a publicação nos canais autorizados.",
            "Solicitar alterações sempre que identificar erros.",
            "Registrar e respeitar as limitações impostas pelo proprietário.",
            "Preencher todas as informações do imóvel (Metragem, IPTU, Condomínio, ano de construção, etc…)",
            "Colocar vídeo do imóvel.",
            "O apoio do Hub Administrativo não transfere a responsabilidade pelo imóvel ou pela qualidade das informações. É responsabilidade do corretor verificar todas as alterações feitas pelo HUB Administrativo."
          ]
        },
        {
          "number": 16,
          "title": "Imóveis internos e externos",
          "lines": [
            "Os imóveis poderão ser classificados como:",
            "Internos: disponíveis apenas nos canais internos da 61 Imóveis.",
            "Externos: autorizados para divulgação pública nos canais da empresa (DF Imóveis, Grupo Zap, WImóveis, Instagram, entre outros).",
            "A classificação deverá seguir a autorização do proprietário e as orientações registradas pelo captador.",
            "Nenhum corretor poderá alterar o status do imóvel sem autorização."
          ]
        },
        {
          "number": 17,
          "title": "Imóveis sem fotos internas ou sem possibilidade de visita",
          "lines": [
            "Quando o imóvel permanecer sem fotos por 60 dias, ou sem possibilidade de visita por 60 dias ou apenas como imóvel interno por 60 dias, ele não será retirado automaticamente do captador.",
            "Após o prazo estabelecido, poderá ser aberta a possibilidade de outro corretor tentar autorização para:",
            "Obter autorização para divulgação externa.",
            "Conseguir acesso para produção de fotos.",
            "Conseguir autorização para visitas.",
            "Caso outro corretor consiga transformar o imóvel em público e efetivamente viabilizar sua comercialização, a definição da responsabilidade será compartilhada entre os captadores."
          ]
        },
        {
          "number": 18,
          "title": "Exclusividade de outra imobiliária",
          "lines": [
            "Quando o imóvel estiver sob exclusividade com outro corretor ou imobiliária, o Corretor 61 deverá:",
            "Perguntar apenas quando a exclusividade termina.",
            "Registrar a data de vencimento no sistema.",
            "Encerrar o card com o motivo “Exclusividade”.",
            "É proibido induzir, pedir ou sugerir que o proprietário cancele uma exclusividade vigente."
          ]
        },
        {
          "number": 19,
          "title": "Relação com corretores concorrentes",
          "lines": [
            "É proibido utilizar outro corretor ou imobiliária para obter informações sobre um imóvel que se deseja captar.",
            "Também é vedado entrar em contato com o atual captador do imóvel para obter informações e acelerar a captação.",
            "Caso o Corretor 61 trate do imóvel com o captador atual, ficará impedido de realizar a captação de forma independente. A partir desse momento, qualquer visita ou venda deverá ocorrer em parceria com o profissional que já atendia o imóvel."
          ]
        },
        {
          "number": 20,
          "title": "Imóvel retirado de venda ou captação encerrada",
          "lines": [
            "Quando o imóvel sair de venda ou o corretor desistir da captação, o card da Jornada de Captação do Sistema da Inteligência 61 deverá ser encerrado no sistema.",
            "Essa regra vale para imóveis que estejam nas etapas de:",
            "Escolha.",
            "Prospecção.",
            "Interação.",
            "Apresentação.",
            "O corretor deverá registrar corretamente o motivo do encerramento."
          ]
        },
        {
          "number": 21,
          "title": "Proprietário como comprador",
          "lines": [
            "A responsabilidade pela captação do imóvel não significa exclusividade sobre o proprietário como comprador.",
            "Caso o proprietário queira comprar outro imóvel, ele poderá ser atendido por qualquer corretor da empresa. Da mesma forma, caso queira autorizar a venda de outro imóvel, qualquer corretor poderá atendê-lo.",
            "A prioridade de atendimento será comprovada pela Ficha de Visita corretamente preenchida e lançada no sistema. A prioridade existe somente para o imóvel visitado, nunca para o cliente."
          ]
        },
        {
          "number": 22,
          "title": "Prioridade de atendimento ao comprador",
          "lines": [
            "A prioridade estará sempre vinculada especificamente ao imóvel, nunca à pessoa do cliente.",
            "No imóvel captado, pela Autorização de Venda válida e pelo cadastro correto.",
            "No imóvel visitado, pela Ficha de Visita devidamente assinada e lançada no sistema.",
            "Sem o registro obrigatório, não haverá garantia de prioridade."
          ]
        },
        {
          "number": 23,
          "title": "Duas visitas para o mesmo cliente",
          "lines": [
            "Quando dois corretores agendarem uma visita para o mesmo cliente e no mesmo imóvel, terá prioridade a visita que ocorrer primeiro, desde que esteja corretamente documentado e registrado no sistema."
          ]
        },
        {
          "number": 24,
          "title": "Conflitos e divergências",
          "lines": [
            "Todo problema relacionado a captação, visitas, divulgação, clientes ou atuação entre corretores deverá ser resolvido internamente por intermédio exclusivo do gestor.",
            "Não é permitido:",
            "Discutir diretamente com outro corretor.",
            "Expor conflitos internos ao proprietário.",
            "Criticar colegas, gestores ou a empresa.",
            "Demonstrar desorganização.",
            "Prejudicar outro corretor perante clientes ou proprietários.",
            "A imagem da 61 Imóveis deverá ser preservada em todas as situações.",
            "Assuntos relacionados a este tópico deverão ser tratados com absoluto sigilo, exclusivamente na sala do gestor e fora do salão, preservando a confidencialidade das informações envolvidas."
          ]
        },
        {
          "number": 25,
          "title": "Regra geral",
          "lines": [
            "Na 61 Imóveis, valem os fatos devidamente documentados e registrados.",
            "Acordos verbais, conversas informais, amizades ou contatos anteriores não substituem:",
            "A autorização de captação.",
            "O cadastro correto no sistema.",
            "A Ficha de Visita.",
            "As observações internas.",
            "A autorização do gestor.",
            "Toda decisão deverá respeitar os documentos oficiais, os registros dos sistemas e as regras internas da empresa."
          ]
        }
      ],
      "groups": [
        {
          "title": "PRIORIDADE E PROPRIEDADE DA CAPTAÇÃO",
          "rules": [
            1,
            2,
            3,
            4,
            5,
            6
          ]
        },
        {
          "title": "IMÓVEIS INTERNOS E EXTERNOS",
          "rules": [
            7,
            16,
            17
          ]
        },
        {
          "title": "VISITAS",
          "rules": [
            8,
            9,
            10,
            11,
            23
          ]
        },
        {
          "title": "DIVULGAÇÃO",
          "rules": [
            12,
            13,
            14,
            15
          ]
        },
        {
          "title": "RELACIONAMENTO E CONDUTA",
          "rules": [
            18,
            19,
            20,
            21,
            22,
            24,
            25
          ]
        }
      ]
    },
    {
      "id": 2,
      "title": "SOBRE CLIENTES E LEADS",
      "label": "Clientes e Leads",
      "intro": [],
      "rules": [
        {
          "number": 1,
          "title": "Responsabilidade pelo Lead",
          "lines": [
            "O lead será direcionado ao corretor captador do imóvel ou ao corretor indicado no cadastro do imóvel.",
            "Os gestores possuem autonomia para direcionar os leads entre os corretores de sua equipe, conforme sua avaliação e estratégia comercial."
          ]
        },
        {
          "number": 2,
          "title": "Registro Obrigatório",
          "lines": [
            "Todo atendimento deverá ser registrado nos sistemas oficiais da empresa.",
            "É obrigatório registrar:",
            "informações da Jornada de Captação;;",
            "visitas realizadas.",
            "Toda visita deverá ser lançada no sistema Inteligência 61 conforme os procedimentos da empresa.",
            "Na ausência de registro, o atendimento será considerado não realizado."
          ]
        },
        {
          "number": 3,
          "title": "Prioridade de Atendimento",
          "lines": [
            "Nenhum corretor possui exclusividade sobre um cliente apenas por ter conversado ou mantido contato com ele.",
            "A prioridade existe apenas ao imóvel específico e deverá ser comprovada por meio da Ficha de Visita devidamente preenchida e registrada nos sistemas oficiais da empresa.",
            "Importante: não existe prioridade sobre o cliente de captação."
          ]
        },
        {
          "number": 4,
          "title": "Conduta no Atendimento",
          "lines": [
            "O corretor deverá atuar com profissionalismo, transparência e boa-fé em todas as etapas do atendimento.",
            "É obrigatório:",
            "fornecer informações verdadeiras;",
            "manter o cliente informado durante a negociação;",
            "agir com cordialidade e respeito;",
            "orientar o cliente com imparcialidade.",
            "É proibido:",
            "criar falsas expectativas;",
            "omitir informações relevantes;",
            "prometer condições que não possam ser cumpridas;",
            "induzir o cliente ao erro."
          ]
        },
        {
          "number": 5,
          "title": "Confidencialidade",
          "lines": [
            "Todas as informações referentes aos clientes deverão ser tratadas com absoluto sigilo.",
            "É proibido compartilhar dados pessoais, documentos, informações financeiras ou qualquer informação obtida durante o atendimento sem autorização ou necessidade operacional.",
            "O dever de confidencialidade permanece mesmo após o encerramento da parceria com a empresa."
          ]
        },
        {
          "number": 6,
          "title": "Conflitos sobre Clientes",
          "lines": [
            "Toda divergência envolvendo prioridade de atendimento, visitas ou propostas será analisada pelos gestores.",
            "Quando necessário, a Diretoria Comercial decidirá sobre situações excepcionais.",
            "Os corretores não deverão resolver conflitos diretamente entre si."
          ]
        }
      ],
      "groups": [
        {
          "title": "LEADS E REGISTROS",
          "rules": [
            1,
            2
          ]
        },
        {
          "title": "ATENDIMENTO E CONDUTA",
          "rules": [
            3,
            4
          ]
        },
        {
          "title": "SIGILO E CONFLITOS",
          "rules": [
            5,
            6
          ]
        }
      ]
    },
    {
      "id": 3,
      "title": "SOBRE REDES SOCIAIS, MARCA E CATEGORIAS",
      "label": "Redes Sociais, Marca e Categorias",
      "intro": [],
      "rules": [
        {
          "number": 1,
          "title": "Identificação como profissional da 61 Imóveis",
          "lines": [
            "Todo corretor deve se identificar como profissional da 61 Imóveis em suas redes sociais e divulgações, mantendo clara sua associação com a empresa.",
            "É obrigatório:",
            "Utilizar @61imoveis na bio das redes sociais;",
            "Identificar a 61 Imóveis nos textos dos imóveis divulgados;",
            "Utilizar a marca da 61 Imóveis exclusivamente conforme os padrões oficiais da empresa;",
            "Utilizar apenas logotipos, artes e materiais institucionais oficiais;",
            "Preservar a identidade visual da empresa em todas as divulgações;",
            "Remover toda referência à 61 Imóveis imediatamente após o encerramento da parceria.",
            "É proibido:",
            "Alterar a identidade visual da 61 Imóveis;",
            "Criar logotipos, selos ou marcas próprias;",
            "Utilizar a marca da 61 Imóveis para fins particulares ou não autorizados;",
            "Utilizar a marca da empresa em conjunto com outras marcas sem autorização da Diretoria."
          ]
        },
        {
          "number": 2,
          "title": "Redes Sociais",
          "lines": [
            "É obrigatório:",
            "Manter postura ética e profissional em todas as publicações.",
            "Preservar a imagem, a reputação e os valores da 61 Imóveis.",
            "Divulgar apenas informações verdadeiras e atualizadas.",
            "É proibido:",
            "Publicar conteúdos que prejudiquem a imagem da 61 Imóveis, de seus clientes, parceiros, colaboradores ou corretores.",
            "Publicar informações internas, estratégicas ou confidenciais da empresa.",
            "Divulgar documentos, contratos, propostas, treinamentos, indicadores ou processos internos sem autorização.",
            "Expor dados, imagens ou informações de clientes, proprietários ou negociações sem autorização.",
            "Responder ou representar oficialmente a 61 Imóveis sem autorização."
          ]
        },
        {
          "number": 3,
          "title": "Divulgação de Imóveis",
          "lines": [
            "É obrigatório:",
            "Divulgar apenas imóveis autorizados para comercialização pela 61 Imóveis.",
            "Utilizar informações compatíveis com o cadastro oficial do imóvel.",
            "Respeitar os padrões de divulgação estabelecidos pela empresa.",
            "É proibido:",
            "Anunciar imóveis sem autorização.",
            "Divulgar imóveis com informações incorretas, incompletas ou desatualizadas.",
            "Alterar valores, características ou condições do imóvel sem autorização do proprietário.",
            "Utilizar fotografias, vídeos ou materiais sem autorização.",
            "Anunciar imóveis que não estejam na carteira de imóveis da 61.",
            "Utilizar marca própria para divulgação dos imóveis ou serviços.",
            "Utilizar portais contratados pelo próprio corretor.",
            "Manter ou divulgar site próprio relacionado à atividade imobiliária."
          ]
        },
        {
          "number": 4,
          "title": "Categorias e Reconhecimentos",
          "lines": [
            "Utilizar categorias, clubes, selos e reconhecimentos apenas quando oficialmente concedidos pela 61 Imóveis.",
            "Utilizar os materiais oficiais fornecidos pela empresa para identificação das categorias.",
            "É proibido:",
            "Utilizar categorias ou selos não conquistados.",
            "Criar categorias ou reconhecimentos próprios.",
            "Manter a utilização de categorias, selos ou reconhecimentos da 61 Imóveis após o encerramento da parceria."
          ]
        },
        {
          "number": 5,
          "title": "Conteúdo Institucional",
          "lines": [
            "É proibido:",
            "Reproduzir, alterar ou utilizar materiais produzidos pela 61 Imóveis para fins particulares sem autorização.",
            "Compartilhar materiais internos da empresa com terceiros.",
            "Utilizar conteúdos institucionais em benefício próprio ou de terceiros sem autorização."
          ]
        }
      ],
      "groups": [
        {
          "title": "IDENTIDADE E COMUNICAÇÃO",
          "rules": [
            1,
            2
          ]
        },
        {
          "title": "DIVULGAÇÃO E RECONHECIMENTOS",
          "rules": [
            3,
            4,
            5
          ]
        }
      ]
    },
    {
      "id": 4,
      "title": "SOBRE PROPOSTAS E NEGOCIAÇÕES",
      "label": "Propostas e Negociações",
      "intro": [],
      "rules": [
        {
          "number": 1,
          "title": "Alinhamento da Proposta",
          "lines": [
            "Toda proposta deverá ser comunicada ao Gerente antes de ser apresentada ao proprietário.",
            "Toda negociação deverá ser tratada no grupo com CEO, Diretor, Gerente, Captador, Vendedor e HUB.",
            "A estratégia da negociação deverá ser definida em conjunto entre o Corretor, o Gerente e, quando necessário, a Diretoria Comercial.",
            "Nenhuma proposta deverá ser apresentada ao proprietário sem o alinhamento prévio da equipe envolvida"
          ]
        },
        {
          "number": 2,
          "title": "Formalização da Proposta",
          "lines": [
            "Toda proposta deverá ser formalizada por escrito.",
            "A proposta deverá conter:",
            "valor ofertado;",
            "forma de pagamento;",
            "origem dos recursos;",
            "prazos de pagamento;",
            "prazo para entrega do imóvel;",
            "o que fica no imóvel;",
            "se tem permuta;",
            "demais condições da negociação.",
            "Não serão aceitas propostas verbais como instrumento oficial de negociação."
          ]
        },
        {
          "number": 3,
          "title": "Apresentação das Propostas",
          "lines": [
            "Todas as propostas recebidas deverão ser apresentadas ao proprietário.",
            "É proibido omitir, reter ou deixar de apresentar qualquer proposta.",
            "A primeira proposta formalizada possui prioridade na negociação.",
            "Quando houver duas ou mais propostas para o mesmo imóvel, todas deverão ser apresentadas ao proprietário.",
            "Nessa situação, o proprietário deverá formalizar sua decisão por meio do documento oficial da empresa, indicando expressamente qual proposta deseja aceitar."
          ]
        },
        {
          "number": 4,
          "title": "Negociação",
          "lines": [
            "Toda negociação deverá ser conduzida com transparência, ética e boa-fé.",
            "O corretor não deverá assumir compromissos em nome da empresa sem autorização.",
            "Qualquer negociação excepcional deverá ser submetida à Diretoria Comercial."
          ]
        },
        {
          "number": 5,
          "title": "Grupo de Negociação",
          "lines": [
            "Toda proposta deverá possuir um grupo oficial de negociação.",
            "O grupo deverá ser composto, obrigatoriamente, pelo Diretor Comercial, Gerente e Corretor(es) responsável(is).",
            "Após a assinatura do contrato, o setor de Pós-Contrato deverá ser incluído no grupo para acompanhar a negociação até a entrega das chaves."
          ]
        },
        {
          "number": 6,
          "title": "Conflitos entre Propostas",
          "lines": [
            "Nos casos em que houver mais de uma proposta para o mesmo imóvel, todo o processo deverá ser acompanhado pela Diretoria Comercial.",
            "É proibido favorecer qualquer proposta por interesse pessoal ou deixar de observar as regras e os critérios estabelecidos pela empresa."
          ]
        }
      ],
      "groups": [
        {
          "title": "PROPOSTAS",
          "rules": [
            1,
            2,
            3
          ]
        },
        {
          "title": "NEGOCIAÇÃO E ALINHAMENTO",
          "rules": [
            4,
            5,
            6
          ]
        }
      ]
    },
    {
      "id": 5,
      "title": "SOBRE CONTRATO E PÓS-CONTRATO",
      "label": "Contrato e Pós-Contrato",
      "intro": [],
      "rules": [
        {
          "number": 1,
          "title": "Produção do Contratos e Termos Aditivos",
          "lines": [
            "A elaboração do contrato e termo aditivo é de responsabilidade do Gerente Comercial.",
            "Mesmo quando houver apoio do setor Jurídico, a responsabilidade pela conferência e validação do contrato permanece sendo do Gerente.",
            "Antes da assinatura, o Gerente deverá conferir todos os dados.",
            "Ao autorizar a assinatura do contrato e termo aditivo, o Gerente assume a responsabilidade pelas informações constantes no documento.",
            "Situações excepcionais deverão ser submetidas à Diretoria Comercial."
          ]
        },
        {
          "number": 2,
          "title": "Documentação da Negociação",
          "lines": [
            "É obrigatório apresentar toda a documentação do imóvel, do comprador e do vendedor antes da assinatura do contrato.",
            "Documentações incompletas ou com inconsistências deverão ser regularizadas antes do prosseguimento da negociação.",
            "Situações documentais que apresentem dúvidas ou riscos deverão ser analisadas pela Diretoria."
          ]
        },
        {
          "number": 3,
          "title": "Assinatura do Contrato",
          "lines": [
            "Nenhum contrato poderá ser assinado sem a validação do Gerente Comercial.",
            "Após a assinatura, a negociação deverá seguir o fluxo oficial da 61 Imóveis:",
            "1. Contrato assinado",
            "↓",
            "2. Inclusão imediata do Pós-Contrato no Grupo de Alinhamento da negociação",
            "↓",
            "3. Envio do contrato e da documentação da negociação ao Pós-Contrato",
            "↓",
            "4. Conferência e acompanhamento das obrigações previstas no contrato",
            "↓",
            "5. Acompanhamento dos pagamentos e demais condições da negociação",
            "↓",
            "6. Acompanhamento da documentação necessária para a transferência do imóvel",
            "↓",
            "7. Escritura/financiamento/vistoria de imóvek junto à instituição financeira",
            "↓",
            "8. Registro da transferência de propriedade na matrícula do imóvel",
            "↓",
            "9. Confirmação da conclusão dos pagamentos",
            "↓",
            "10. Entrega das chaves e conclusão da negociação",
            "A partir da assinatura do contrato, o Pós-Contrato passa a conduzir e acompanhar as etapas necessárias até a conclusão do negócio, mantendo comprador, vendedor, corretor e demais envolvidos alinhados.",
            "Importante: a entrada do Pós-Contrato não encerra a participação do corretor. O corretor é responsável pelo acompanhamento do cliente e contribui para uma boa experiência até a finalização da negociação."
          ]
        },
        {
          "number": 4,
          "title": "Pós-Contrato",
          "lines": [
            "Após a assinatura do contrato, o corretor continua sendo responsável por acompanhar a negociação até sua conclusão, atuando em conjunto com o setor de Pós-Contrato.",
            "É obrigatório ao corretor:",
            "Permanecer disponível para apoiar compradores, vendedores e o setor de Pós-Contrato sempre que necessário.",
            "Comparecer presencialmente à assinatura da escritura, salvo autorização do Gerente Comercial.",
            "Comparecer presencialmente à entrega das chaves, garantindo uma boa experiência para as partes e o encerramento adequado da negociação.",
            "Acompanhar o andamento da negociação e manter contato com o cliente durante todo o processo.",
            "Auxiliar na resolução de pendências quando solicitado pelo setor de Pós-Contrato ou pelo Gerente.",
            "Acompanhar a avaliação realizada pelo agente financiador.",
            "Acompanhar a vistoria realizada pelo banco.",
            "Acompanhar a vistoria final do imóvel antes da entrega das chaves."
          ]
        },
        {
          "number": 5,
          "title": "Financiamento",
          "lines": [
            "O setor de Pós-Contrato acompanha exclusivamente financiamentos realizados pela 61 Imóveis.",
            "Financiamentos externos não serão acompanhados pelo setor."
          ]
        }
      ],
      "groups": [
        {
          "title": "CONTRATOS E DOCUMENTAÇÃO",
          "rules": [
            1,
            2
          ]
        },
        {
          "title": "ASSINATURA E ACOMPANHAMENTO",
          "rules": [
            3,
            4,
            5
          ]
        }
      ]
    },
    {
      "id": 6,
      "title": "SOBRE PARCERIAS",
      "label": "Parcerias",
      "intro": [],
      "rules": [
        {
          "number": 1,
          "title": "Parcerias Externas",
          "lines": [
            "A 61 Imóveis incentiva parcerias com outras imobiliárias e corretores sempre que contribuírem para a concretização de negócios e para a melhor experiência do cliente.",
            "Antes de iniciar qualquer negociação em parceria, é obrigatório consultar a Planilha Oficial de Parcerias, que contém:",
            "percentual de divisão da comissão;",
            "regras específicas de cada imobiliária;",
            "restrições comerciais;",
            "observações e histórico de relacionamento.",
            "Antes de formalizar qualquer parceria, o corretor deverá:",
            "verificar a política de divisão da comissão;",
            "alinhar previamente todas as condições da negociação com o gestor;",
            "esclarecer eventuais dúvidas com o gestor antes de prosseguir.",
            "Os percentuais de parceria são recíprocos entre as empresas.",
            "Imobiliárias estruturadas (escritório físico, CNPJ, equipe com mais de 3 corretores e carteira superior a 30 imóveis) seguem a divisão padrão de 50% / 50%, salvo disposição diferente na Planilha Oficial de Parcerias."
          ]
        },
        {
          "number": 2,
          "title": "Parcerias Internas",
          "lines": [
            "A parceria entre corretores da 61 Imóveis deve ser pautada pela ética, transparência e respeito ao trabalho dos colegas.",
            "Todo acordo de coparticipação deverá ser definido previamente, registrado por escrito e respeitado integralmente.",
            "Nos casos de parceria entre corretores, seja na captação, no atendimento ao comprador ou em qualquer outra participação no negócio, a divisão acordada entre as partes deverá estar expressamente documentada.",
            "Caso não exista acordo registrado por escrito, a receita referente à participação dos corretores no respectivo negócio será dividida igualmente: 50% para cada parte."
          ]
        },
        {
          "number": 3,
          "title": "Regras de Parceria",
          "lines": [
            "É obrigatório:",
            "respeitar os acordos firmados entre os corretores;",
            "cumprir os percentuais definidos para cada modalidade de parceria;",
            "comunicar o gestor sempre que houver parceria na negociação;",
            "utilizar os registros oficiais da empresa para formalizar a parceria.",
            "É proibido:",
            "alterar acordos após o início da negociação sem concordância de todas as partes;",
            "omitir a participação de outro corretor;",
            "excluir um parceiro da negociação sem justificativa e autorização;",
            "descumprir acordos de divisão de comissão."
          ]
        },
        {
          "number": 4,
          "title": "Conflitos de Parceria",
          "lines": [
            "Eventuais divergências deverão ser tratadas exclusivamente pelos canais internos da empresa.",
            "O fluxo para resolução de conflitos será:",
            "Análise do Gerente Comercial;",
            "Verificação dos registros oficiais da empresa;",
            "Decisão da Diretoria Comercial, quando necessária.",
            "A decisão da Diretoria Comercial será considerada definitiva."
          ]
        }
      ],
      "groups": [
        {
          "title": "PARCERIAS EXTERNAS E INTERNAS",
          "rules": [
            1,
            2
          ]
        },
        {
          "title": "ACORDOS E CONFLITOS",
          "rules": [
            3,
            4
          ]
        }
      ]
    }
  ]
};
